export default __webpack_public_path__ + "static/Plots0061-aae015b083be11668b7f1dbfbb7c307e.jpg";